import cn from 'classnames';
import React, { PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
  className?: string;
}>;

const RowBreak = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { children, className } = props;

  const classNames = cn('clr-break-row', className);

  return (
    <div ref={ref} className={classNames}>
      {children}
    </div>
  );
});

export default RowBreak;
